var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, delay, put, race, take } from 'redux-saga/effects';
import { delayAfterPollingInMS, delayBeforeStartPollingInMS } from '~store';
import { executeRequest } from '~utils/executeRequest';
import { getExcludedOffersSuccess, getTopRankingPoll, getTopRankingPollStop, getTopRankingPollSuccess, } from './index';
function pollTopRanking(payload) {
    var errorResult_1, response, data, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 9, , 11]);
                return [4 /*yield*/, delay(delayBeforeStartPollingInMS)];
            case 1:
                _a.sent();
                errorResult_1 = null;
                return [4 /*yield*/, call(executeRequest, {
                        url: "ticket/v1/tickets/check/poll?requestId=".concat(payload),
                        options: {
                            method: 'POST',
                            credentials: 'include',
                        },
                        setError: function (err) {
                            errorResult_1 = err;
                        },
                    })];
            case 2:
                response = _a.sent();
                if (!response || !('data' in response) || 'error' in response) {
                    throw errorResult_1 || new Error('Unexpected error');
                }
                data = response.data;
                if (!Object.keys(data || {}).length) return [3 /*break*/, 6];
                return [4 /*yield*/, put(getTopRankingPollSuccess((data === null || data === void 0 ? void 0 : data.rankingList) || []))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(getExcludedOffersSuccess((data === null || data === void 0 ? void 0 : data.excludedOffers) || []))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(getTopRankingPollStop())];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, delay(delayAfterPollingInMS)];
            case 7:
                _a.sent();
                return [4 /*yield*/, call(pollTopRanking, payload)];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9:
                err_1 = _a.sent();
                console.error(err_1);
                return [4 /*yield*/, put(getTopRankingPollStop())];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
export function pollTopRankingWatcher() {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, take(getTopRankingPoll)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, race([
                        call(pollTopRanking, payload),
                        take(getTopRankingPollStop.toString()),
                    ])];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
}
